import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { PrimeReactProvider, addLocale, locale } from 'primereact/api';


import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import 'primereact/resources/primereact.css';

import './assets/demo/flags/flags.css';
import './assets/demo/Demos.scss';
import './assets/layout/layout.scss';
import './GlobalOverrides.css';


import Menu from './pages/Menu';
import Login from './pages/Login';
import Register from './pages/Register';
import Usuario from './pages/configuracion/Usuario';
import Permisos from './pages/configuracion/Permisos';
import Perfil from './pages/Perfil';
import Dashboard from './pages/dashboard/Dashboard';
import ReportesDashboard from './pages/dashboard/ReportesDashboard';
import Temas from './pages/Temas';
import Empresas from './pages/Empresas';
import Clientes from './pages/mantenimiento/Clientes';
import Interesados from './pages/mantenimiento/Interesados';
import Vendedores from './pages/mantenimiento/Vendedores';
import Lotizacion from './pages/mantenimiento/Lotizacion';
import Series from './pages/mantenimiento/Series';
import NuevoRegistro from './pages/operaciones/NuevoRegistro';
import ListaCotizaciones from './pages/operaciones/ListaCotizaciones';
import Contrato from './pages/operaciones/Contrato';
import ListaContratos from './pages/operaciones/ListaContratos';
import DetalleContrato from './pages/operaciones/DetalleContrato';
import ReporteComisiones from './pages/reportes/ReporteComisiones';
import ReporteLotes from './pages/reportes/ReporteLotes';
import ReporteMaestro from './pages/reportes/ReporteMaestro';
import ReportePagos from './pages/reportes/ReportePagos';
import ArqueoCaja from './pages/reportes/ArqueoCaja';
import DepositosBancarios from './pages/reportes/DepositosBancarios';

addLocale('es', {
    firstDayOfWeek: 1,
    dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
    dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    today: 'Hoy',
    clear: 'Limpiar'
});
locale('es');

function App() {
  return (
    <PrimeReactProvider>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route exact path="/" element={<Menu />} >
              <Route exact path="/usuario" element={<Usuario />} />
              <Route exact path="/permisos" element={<Permisos />} />
              <Route exact path="/perfil" element={<Perfil />} />
              <Route exact path="/dashboard" element={<Dashboard />} />
              <Route exact path="/reportes" element={<ReportesDashboard />} />
              <Route exact path="/reportes/lotes" element={<ReporteLotes />} />
              <Route exact path="/reportes/comisiones" element={<ReporteComisiones />} />
              <Route exact path="/reportes/maestro" element={<ReporteMaestro />} />
              <Route exact path="/reportes/pagos" element={<ReportePagos />} />
              <Route exact path="/reportes/arqueo-caja" element={<ArqueoCaja />} />
              <Route exact path="/reportes/depositos-bancarios" element={<DepositosBancarios />} />
              <Route exact path="/temas" element={<Temas />} />
              <Route exact path="/empresas" element={<Empresas />} />
              <Route exact path="/clientes" element={<Clientes />} />
              <Route exact path="/interesados" element={<Interesados />} />
              <Route exact path="/vendedores" element={<Vendedores />} />
              <Route exact path="/lotizacion" element={<Lotizacion />} />
              <Route exact path="/series" element={<Series />} />
              <Route exact path="/cotizacion" element={<NuevoRegistro />} />
              <Route exact path="/cotizacion/lista" element={<ListaCotizaciones />} />
              <Route exact path="/historial-comercial" element={<ListaContratos />} />
              <Route exact path="/contrato/nuevo" element={<Contrato />} />
              <Route exact path="/detalle_contrato/:id" element={<DetalleContrato />} />
            </Route>
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/register" element={<Register />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </PrimeReactProvider>
  );
}

export default App;

